import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Carousel from '@/atoms/Carousel/Carousel'

/* styling */
import styles from './_.module.css'

interface Props {
  list: StrapiTestimonialAttributes[]
}

function CaseStudyTestimonial({ list }: Props) {
  return (
    <section className="">
      <div className="container | py-14 md:py-18">
        <Carousel
          className="mx-auto | overflow-hidden"
          autoScroll={false}
          sliderClassName="p-2"
          indicatorSize="sm"
          slides={list.map(item => (
            <div
              key={item.authorName}
              className={clsx(
                'grid grid-cols-1 md:grid-cols-12 gap-8 | mx-auto rounded-xl',
                styles.testimonialBg
              )}
            >
              <div className="md:col-span-5 flex justify-center | overflow-hidden">
                {item.companyImage?.data?.attributes.url ? (
                  <Image
                    src={item.companyImage.data.attributes.url}
                    alt={
                      item.companyImage.data.attributes.alternativeText ?? ''
                    }
                    width={item.companyImage.data.attributes.width}
                    height={item.companyImage.data.attributes.height}
                    className="object-cover rounded-tl-xl rounded-tr-xl md:rounded-tr-none md:rounded-tl-xl md:rounded-bl-xl"
                  />
                ) : null}
              </div>
              <div className="md:col-span-7 | px-6 pb-8 md:px-8 md:py-20">
                <div>
                  <div className="font-heading | text-xl md:text-3xl text-gray-90 | max-w-col-6 md:pr-20 mb-9 md:mb-10">
                    {item.review}
                  </div>
                  <div className="font-body | flex items-center gap-5 md:gap-10">
                    {item.authorImage?.data?.attributes.url ? (
                      <Image
                        src={item.authorImage.data.attributes.url ?? ''}
                        alt={
                          item.authorImage.data.attributes.alternativeText ?? ''
                        }
                        width={item.authorImage.data.attributes.width}
                        height={item.authorImage.data.attributes.height}
                        className="w-12 h-12 rounded-full"
                      />
                    ) : null}
                    <div>
                      <p className="text-base md:text-2xl font-medium | mb-1">
                        {item.authorName}
                      </p>
                      <p className="text-xs md:text-lg text-gray-70">
                        {item.authorDesignation}, {item.company}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        />
      </div>
    </section>
  )
}

export default CaseStudyTestimonial
